import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { MeetingsList } from '@/components/MeetingsList';
import { CreateMeetingModal } from '@/components/CreateMeetingModal';
import { useState } from 'react';
import {
  IressContainer,
  IressStack,
  IressText,
  IressAlert,
} from '@iress-oss/ids-components';
import { createMeeting } from '@/lib/api';
import { meetingsQueryOptions } from '@/lib/query/meetingsQuery';
import { AiDisclaimer } from '@/components/AiDisclaimer';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createError, setCreateError] = useState<string | null>(null);

  // v8 ignore next
  const handleCloseCreateModal = () => setShowCreateModal(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return (
    <IressContainer py="lg">
      <IressStack gap="spacing.6">
        <header>
          <IressStack gap="spacing.2">
            <IressText element="h1" textStyle="typography.heading.1">
              Xplan Meeting Assistant
            </IressText>
            <IressText textStyle="typography.body.md">
              AI powered assistant for Xplan Workflows - Meeting Preparation and
              Management
            </IressText>
            <AiDisclaimer />
          </IressStack>
        </header>

        <MeetingsList
          onFinalise={(meeting) => {
            void navigate({
              to: '/$id/summarise',
              params: { id: meeting.id },
            });
          }}
          onCreate={() => setShowCreateModal(true)}
          onManageTemplates={() => {
            void navigate({ to: '/templates' });
          }}
        />

        <CreateMeetingModal
          show={showCreateModal}
          /* v8 ignore next */
          onClose={handleCloseCreateModal}
          /* v8 ignore next 15 -- create flow tested via integration test */
          onCreate={async (data) => {
            try {
              const created = await createMeeting(data);
              setShowCreateModal(false);
              void queryClient.invalidateQueries({
                queryKey: meetingsQueryOptions.queryKey,
              });
              void navigate({
                to: '/$id/summarise',
                params: { id: created.id },
              });
              /* v8 ignore next 2 -- network error path */
            } catch {
              setCreateError('Failed to create meeting. Please try again.');
            }
          }}
        />
        {createError && <IressAlert status="danger">{createError}</IressAlert>}
      </IressStack>
    </IressContainer>
  );
}
